const UNKNOWN_GRADE = {
  color: "#cbd5e1",
  label: "등급 미확인",
  className: "item-grade-unknown grade-unknown",
};

const ITEM_GRADE_MAP = {
  common: {
    color: "#9ca3af",
    label: "일반",
    className: "item-grade-common grade-common",
  },
  uncommon: {
    color: "#22c55e",
    label: "고급",
    className: "item-grade-uncommon grade-uncommon",
  },
  rare: {
    color: "#3b82f6",
    label: "희귀",
    className: "item-grade-rare grade-rare",
  },
  epic: {
    color: "#a855f7",
    label: "영웅",
    className: "item-grade-epic grade-epic",
  },
  legend: {
    color: "#f59e0b",
    label: "전설",
    className: "item-grade-legend grade-legend",
  },
  mythic: {
    color: "#ef4444",
    label: "초월",
    className: "item-grade-mythic grade-mythic",
  },
};

const ITEM_GRADE_ALIASES = {
  common: "common",
  normal: "common",
  basic: "common",
  "일반": "common",
  uncommon: "uncommon",
  advanced: "uncommon",
  uncommonitem: "uncommon",
  "고급": "uncommon",
  rare: "rare",
  "희귀": "rare",
  epic: "epic",
  heroic: "epic",
  hero: "epic",
  "영웅": "epic",
  legend: "legend",
  legendary: "legend",
  "전설": "legend",
  mythic: "mythic",
  transcendent: "mythic",
  transcendence: "mythic",
  "초월": "mythic",
};

export function normalizeItemGrade(grade) {
  if (grade === null || grade === undefined) {
    return "unknown";
  }

  const normalized = String(grade)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]/g, "");

  if (!normalized) {
    return "unknown";
  }

  return ITEM_GRADE_ALIASES[normalized] || "unknown";
}

export function getItemGradeColor(grade) {
  const gradeKey = normalizeItemGrade(grade);

  return ITEM_GRADE_MAP[gradeKey]?.color || UNKNOWN_GRADE.color;
}

export function getItemGradeLabel(grade) {
  const gradeKey = normalizeItemGrade(grade);

  return ITEM_GRADE_MAP[gradeKey]?.label || UNKNOWN_GRADE.label;
}

export function getItemGradeClass(grade) {
  const gradeKey = normalizeItemGrade(grade);

  return ITEM_GRADE_MAP[gradeKey]?.className || UNKNOWN_GRADE.className;
}
